import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {SentryInterceptor} from 'dra-lib';
import {AuthInterceptor} from './auth.interceptor';

export const draHttpInterceptorProviders = [
  {provide: HTTP_INTERCEPTORS, useClass: SentryInterceptor, multi: true},
  {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
];
